export enum Feature {
  LOCALIZATION = "LOCALIZATION",
  CANCEL_APPLICATION = "CANCEL_APPLICATION",
  ATTACHMENT_UPLOAD = "ATTACHMENT_UPLOAD",
  MULTIPLE_BASIC_ACCOUNT_APPLICATIONS_PER_PRODUCT = "MULTIPLE_BASIC_ACCOUNT_APPLICATIONS_PER_PRODUCT",
}

export interface PdfFileNameResponse {
  fileName: string;
}
